import {createSlice} from '@reduxjs/toolkit';
import _ from 'lodash'
import {STATUS, CASINO_CATEGORY_TYPE} from '../common/Foundation';
const {NEW} = CASINO_CATEGORY_TYPE;

const defaultLimitSearchingChars = 80;
const defaultLoadMoreItems = 25;
const REPLACE_ITEMS = 3;
const defaultNewCategory = {
	id: -1,
	categoryName: 'New',
	isDefault: true,
	orderBy: 2,
};
const defaultProviders = [
	{providerId: -2, providerName: "All Providers", status: STATUS.ACTIVE}
];

const defaultLiveGames = [];

const defaultCategory = {
	'0': {
		mainCategory: {
			id: 0,
			categoryName: 'All Games',
			isDefault: true,
			orderBy: 0,
		},
		subCategory: null
	}
};

export const defaultSubCategory = {
	id: 0,
	categoryName: 'All',
	isDefault: true,
	orderBy: 0,
};

export const defaultSubFavoriteCategory = {
	id: -1,
	categoryName: 'All Favorites',
	isDefault: true,
	orderBy: 0,
};

const defaultFavoriteCategory = {
	'0': {
		mainCategory: {},
		subCategory: defaultSubFavoriteCategory
	}
};

const updateCasinoFilter = (state, key, value) => {
	const tmp = state.casinoFilter;
	tmp[key] = value;
	state.casinoFilter = tmp;
}

const updateNewCategoryProcess = state => {
	_.forEach(state.categories, (cat, key) => {
		const mainCategory = cat['mainCategory'];
		const subCategory = cat['subCategory'];

		if (_.includes(state.listOfSubCategoryForNew, mainCategory.categoryName) && !_.isEmpty(subCategory)) {
			cat['subCategory'] = subCategory.addAll(defaultNewCategory);
		}
	});
}

const updateCategoryProcess = (state, currentCategory) => {
	const mainCategory = currentCategory['mainCategory'];
	let subCategories = !_.isEmpty(currentCategory['subCategory']) ? _.concat([defaultSubCategory], currentCategory['subCategory']) : [];

	if (_.includes(state.listOfSubCategoryForNew, mainCategory.categoryName) && !_.isEmpty(subCategories)) {
		subCategories = _.concat(subCategories, defaultNewCategory);
	}

	const subCategory = _.get(subCategories, '[0]', {});
	const tmp = state.selectedCategory;
	tmp['mainCategory'] = mainCategory;
	tmp['subCategory'] = subCategory;

	state.selectedCategory = tmp;

	let categoryId = '';
	const mainCategoryId = mainCategory.id;
	if (_.isEmpty(currentCategory['subCategory'])) {
		categoryId = (mainCategoryId === -1 || mainCategoryId === 0) ? '' : mainCategoryId;
	} else {
		const subCategoryId = _.get(subCategory, 'id', 0);
		if (subCategoryId !== 0) {
			categoryId = subCategoryId;
		} else if (mainCategoryId !== 0) {
			categoryId = mainCategoryId;
		}
	}

	const {categoryType} = mainCategory;

	if (categoryType === NEW) {
		updateCasinoFilter(state, 'categoryId', '');
		updateCasinoFilter(state, 'isNewGame', true);
	} else {
		updateCasinoFilter(state, 'categoryId', categoryId);
	}
}

const resetCasinoFilter = (state) => {
	state.isLoadMoreGames = false;
	updateCasinoFilter(state, 'beginIndex', 0);
	const defaultLoadMore = state.casinoFilter.providerList.length > 0 ? defaultLoadMoreItems + REPLACE_ITEMS: defaultLoadMoreItems;
	state.numberOfRecordsPerPage = defaultLoadMore;
	state.casinoFilter['moreItems'] = defaultLoadMoreItems;
}

const options = {
	name: 'LiveCasinoSlice',
	initialState: {
		isSearchingGames: false,
		isFetchingGames: false,
		isLoadMoreGames: false,
		isShowCasinoGameWindow: false,
		isLoadingGame: false,
		limitSearchingChars: defaultLimitSearchingChars,
		liveCasinoProviders: [],
		otherCasinoProviders: [],
		loadMoreItems: 16,
		numberOfRecordsPerPage: defaultLoadMoreItems,
		liveCasinoSlider: [],
		selectedGame: {},
		wallets: [],
		liveCasinoGames: [],
		categories: {},
		selectedCategory: {},
		isCasinoFavouriteClicked: false,
		casinoFilter: {
			categoryId: '',
			gameName: '',
			providerId: defaultProviders[0]['providerId'],
			providerName: defaultProviders[0]['providerName'],
			providerList: [],
			beginIndex: 0,
			moreItems: defaultLoadMoreItems,
			orderBy: 'gameName,provider'
		}
	},
	reducers: {
		updateIsSearchingGames: (state, {payload}) => {
			state.isSearchingGames = payload;
		},
		updateIsFetchingGames: (state, {payload}) => {
			state.isFetchingGames = payload;
		},
		updateCasinoFilter: (state, {payload}) => {
			const {key, value} = payload;
			const tmp = state.casinoFilter;
			tmp[key] = value;
			state.casinoFilter = tmp;
		},
		updateMoreItemsFilter: (state, {payload}) => {
			state.isLoadMoreGames = true;
			const moreItems = payload > 0 ? payload : state.loadMoreItems;
			const tmp = state.casinoFilter;
			tmp['beginIndex'] = tmp['beginIndex'] + tmp['moreItems'];
			if (moreItems !== tmp['moreItems']) {
				tmp['moreItems'] = moreItems;
			}
			state.numberOfRecordsPerPage += moreItems;
			state.casinoFilter = tmp;
		},
		clearCasinoGames: (state) => {
			state.liveCasinoGames = [];
		},
		updateCasinoProviderFilter: (state, {payload}) => {
			updateCasinoFilter(state, 'providerList', payload);
		},
		updateWallets: (state, {payload}) => {
			state.wallets = payload;
		},
		updateCasinoGameWindow: (state, {payload}) => {
			state.isShowCasinoGameWindow = payload;
		},
		updateLoadingGame: (state, {payload}) => {
			state.isLoadingGame = payload;
		},
		updateLiveCasinoSlider: (state, {payload}) => {
			state.liveCasinoSlider = payload;
		},
		updateSelectedGame: (state, {payload}) => {
			state.selectedGame = payload;
		},
		updateLiveCasinoGames: (state, {payload}) => {
			if (!_.isEmpty(payload)) {
				if (state.casinoFilter.moreItems < payload.length) {
					state.casinoFilter.moreItems = payload.length;
				}
				if (!state.isLoadMoreGames) {
					state.liveCasinoGames = payload;
				} else {
					const tmp = state.liveCasinoGames;
					state.liveCasinoGames = _.concat(tmp, payload);
				}
			}
		},
		resetCasinoFilter: (state) => resetCasinoFilter(state),
		updateLiveCasinoProviders: (state, {payload}) => {
			state.liveCasinoProviders = [...defaultProviders, ...payload];
		},
		updateCategory: (state, {payload}) => {
			state.categories = _.merge(defaultCategory, payload);
			updateNewCategoryProcess(state);
			updateCategoryProcess(state, defaultCategory[0]);
		},
		selectMainCategory: (state, {payload}) => {
			const currentCategory = state.categories[payload.id] || {};
			resetCasinoFilter(state);
			updateCategoryProcess(state, currentCategory);
		},
		selectSubCategory: (state, {payload}) => {
			resetCasinoFilter(state);
			const tmp = state.selectedCategory;
			tmp['subCategory'] = payload;
			state.selectedCategory = tmp;
			const subCategoryId = _.get(state.selectedCategory, 'subCategory.id', 0);
			const mainCategoryId = _.get(state.selectedCategory, 'mainCategory.id', 0);
			let categoryId = '';
			if (subCategoryId === -1) {
				categoryId = mainCategoryId;
				updateCasinoFilter(state, 'isNewGame', true);
			} else if (subCategoryId !== 0) {
				categoryId = subCategoryId;
			} else if (subCategoryId === 0 && mainCategoryId !== 0) {
				categoryId = mainCategoryId;
				updateCasinoFilter(state, 'isNewGame', '');
			}
			updateCasinoFilter(state, 'categoryId', categoryId);
		},
		resetFavoritesCategory: (state, {payload}) => {
			state.selectedCategory = defaultFavoriteCategory[0];
		},
		updateCasinoProviders: (state, {payload}) => {
			state.casinoProviders = [...defaultProviders, ...payload];
		},
		updateOtherCasinoProviders: (state, {payload}) => {
			state.otherCasinoProviders = payload;
		},
		updateCasinoGames: (state, {payload}) => {
			if (!_.isEmpty(payload)) {
				if (state.casinoFilter.moreItems < payload.length) {
					state.casinoFilter.moreItems = payload.length;
				}
				if (!state.isLoadMoreGames) {
					state.liveCasinoGames = payload;
				} else {
					const tmp = state.liveCasinoGames;
					state.liveCasinoGames = _.concat(tmp, payload);
				}
			}
		},
		setCasinoFavouriteClicked: (state, {payload}) => {
			state.isCasinoFavouriteClicked = payload;
		}
	}
}

export const LiveCasinoSlice = createSlice(options);

export const isAvaiableWalletsSelector = state => {
	let totalBetCredit = 0;
	_.map(state.wallets, wallet => {
		totalBetCredit += wallet.betCredit;
	});
	return totalBetCredit > 0;
}

export const getLimitSearchingCharsSelector = state => state.LiveCasinoSlice.limitSearchingChars;
export const getSelectedProviderSelector = state =>
	state.LiveCasinoSlice.casinoFilter.provider === '' ? defaultProviders[0] :
		{
			providerId: state.LiveCasinoSlice.casinoFilter.providerId,
			providerName: state.LiveCasinoSlice.casinoFilter.providerName
		};
export const getSelectedSubCategoryIdSelector = state => _.get(state.LiveCasinoSlice.selectedCategory, 'subCategory.id', 0);

export default LiveCasinoSlice.reducer;



// WEBPACK FOOTER //
// ./src/app/slices/LiveCasinoSlice.js